import Phonsesfive from "../Detials/phonesfive";
import Otherthree from "../Detials/otherthree"



function Rowthree(){
    return(
        <>
        <Phonsesfive/>
        <Otherthree/>

        </>
    )
}
export default Rowthree